// Navbar.js
import React, { useState, useEffect } from "react";
import MegaMenu from "./MegaMenu";
import "../assets/demoNav.css";
import logo from '../assets/imgs/sglogo.webp';
import insta from "../assets/gallery/instagram.png";
import fb from "../assets/gallery/fb.png";
import linkedin from "../assets/gallery/linkedin.png";
import { Link } from "react-router-dom";

const Navbar = () => {
    const [activeMenu, setActiveMenu] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [mobileDropdown, setMobileDropdown] = useState({ projects: false, career: false, ongoing: false });

    const toggleMenu = (menu) => {
        setActiveMenu(activeMenu === menu ? null : menu);
    };

    const toggleMobileDropdown = (menu) => {
        setMobileDropdown(prev => ({ ...prev, [menu]: !prev[menu] }));
    };

    // Lock body scroll when mobile menu is open
    useEffect(() => {
        document.body.style.overflow = mobileOpen ? "hidden" : "auto";
    }, [mobileOpen]);

    return (
        <>
            {/* TOP BAR */}
            <div className="top-bar">
                <div className="top-left">
                    <span><Link to="whyus">WHY SAMRIDDHI GROUP?</Link></span>
                    <span><Link to="faq">FAQ?</Link></span>
                    <span><Link to="blogs">BLOGS</Link></span>
                    <span><Link to="contact">CONTACT</Link></span>
                </div>
                <div className="top-right">
                    <a href='https://www.instagram.com/samriddhigroupofficial?igsh=c3dhYXFmOGJjYWlp' target='_blank'><img src={insta} alt="instagram" /></a>
                    <a href='https://www.facebook.com/samriddhigroup24/' target='_blank'> <img src={fb} alt="facebook" /></a>
                    <a href='https://www.linkedin.com/company/samriddhigroupofficial/' target='_blank'><img src={linkedin} alt="linkedin" /></a>
                    <span>97300 50099 / 97300 20099</span>
                </div>
            </div>

            {/* MAIN NAV */}
            <nav className="main-nav">
                <div className="nav-left">
                    <Link to="/" className="logo">
                        <img src={logo} alt="Samriddhi Group" />
                    </Link>

                    {/* DESKTOP MENU */}
                    <ul className="menu desktop-menu">
                        <li><Link to="/">HOME</Link></li>
                        <li><Link to="/about">ABOUT</Link></li>
                        <li onClick={() => toggleMenu("projects")}>PROJECTS ▾</li>
                        <li><Link to="/media">MEDIA</Link></li>
                        <li><Link to="/googlereviews">TESTIMONIALS</Link></li>
                        <li onClick={() => toggleMenu("career")}>CAREER ▾</li>
                        <li><Link to="/investmentpuneplots">INVEST IN PUNE</Link></li>
                        <li><Link to="/#">OUR LAND BANK</Link></li>
                        <li><Link to="/#">PROJECT PARTNER</Link></li>
                    </ul>
                </div>

                <div className="nav-right">
                    {/* HAMBURGER */}
                    <div
                        className={`hamburger ${mobileOpen ? "active" : ""}`}
                        onClick={() => setMobileOpen(!mobileOpen)}
                    >
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            </nav>

            {/* MEGA MENU (Desktop Dropdowns) */}
            {activeMenu && (
                <MegaMenu type={activeMenu} onClose={() => setActiveMenu(null)} />
            )}

            {/* MOBILE MENU */}
            <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
                <ul>
                    <li><Link to="/" onClick={() => setMobileOpen(false)}>HOME</Link></li>
                    <li><Link to="/about" onClick={() => setMobileOpen(false)}>ABOUT</Link></li>

                    {/* PROJECTS Dropdown */}
                    <li onClick={() => toggleMobileDropdown("projects")} className="mobile-dropdown">
                        PROJECTS ▾
                    </li>
                    {mobileDropdown.projects && (
                        <>
                            <li className="sub"><Link to="/completedProjects" onClick={() => setMobileOpen(false)}>Completed Projects</Link></li>

                            <li onClick={() => toggleMobileDropdown("ongoing")} className="sub mobile-dropdown">
                                Ongoing Projects ▾
                            </li>
                            {mobileDropdown.ongoing && (
                                <>
                                    <li className="sub-sub"><Link to="waterscape-premium-water-touch-plots" onClick={() => setMobileOpen(false)}>Waterscape</Link></li>
                                    <li className="sub-sub"><Link to="riviera-Greens-dam-view-plots" onClick={() => setMobileOpen(false)}>Riviera Greens</Link></li>
                                    <li className="sub-sub"><a
                                        href="https://www.lonavalley.in"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => setMobileOpen(false)}
                                    >
                                        Lonavalley
                                    </a>
                                    </li>
                                </>
                            )}

                            <li className="sub"><Link to="/upcomingProjects" onClick={() => setMobileOpen(false)}>Upcoming Projects</Link></li>
                        </>
                    )}

                    <li><Link to="/media" onClick={() => setMobileOpen(false)}>MEDIA</Link></li>
                    <li><Link to="/googlereviews" onClick={() => setMobileOpen(false)}>TESTIMONIALS</Link></li>

                    {/* CAREER Dropdown */}
                    <li onClick={() => toggleMobileDropdown("career")} className="mobile-dropdown">
                        CAREER ▾
                    </li>
                    {mobileDropdown.career && (
                        <>
                            <li className="sub"><Link to="/#" onClick={() => setMobileOpen(false)}>CHANNEL PARTNER</Link></li>
                            <li className="sub"><Link to="/life-at-samriddhi-group" onClick={() => setMobileOpen(false)}>EMPLOYMENT</Link></li>
                        </>
                    )}

                    <li><Link to="/investmentpuneplots" onClick={() => setMobileOpen(false)}>INVEST IN PUNE</Link></li>
                    <li><Link to="/#" onClick={() => setMobileOpen(false)}>OUR LAND BANK</Link></li>
                    <li><Link to="/#" onClick={() => setMobileOpen(false)}>PROJECT PARTNER</Link></li>
                </ul>
            </div>

            {/* MOBILE OVERLAY */}
            {mobileOpen && (
                <div className="mobile-overlay" onClick={() => setMobileOpen(false)} />
            )}
        </>
    );
};

export default Navbar;
